export default "__VITE_ASSET__C43MG5j7__"